module.exports = __webpack_public_path__ + "static/media/matsuko.f9725d56.png";